import { LangUri, Environment } from '@catawiki/runtime-toolkit';
/* Function to switch language */
export function reloadPageWithHost(mainHost, locale) {
    try {
        if (locale) {
            const alternate = document.querySelector(`link[rel=alternate][hreflang=${locale}]`);
            if (alternate) {
                const hrefVal = alternate.getAttribute('href');
                if (hrefVal) {
                    location.href = hrefVal;
                }
                return;
            }
        }
        const currentPathParts = (Environment.isClientSide() ? window.location.pathname : '').split('/');
        let slug = '';
        // If current path is migrated (path starts with one of the locale strings)
        if (LangUri.defaultLangPaths.includes(currentPathParts[1])) {
            // Remove the locale string from the pathname
            currentPathParts.splice(1, 1);
            // Construct slug from the pathname without the locale string
            slug = currentPathParts.join('/');
        }
        else {
            slug = Environment.isClientSide() ? window.location.pathname : '';
        }
        if (Environment.isClientSide()) {
            window.location.href = `${location.protocol}//${mainHost}${slug}`;
        }
    }
    catch {
        if (Environment.isClientSide()) {
            location.href = mainHost;
        }
    }
}
//# sourceMappingURL=reloadWithHost.js.map